module.exports = __webpack_public_path__ + "static/img/xls2.266054b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/xls2.png
// module id = XZaq
// module chunks = 1